module.exports = __webpack_public_path__ + "img/elizabeth-peloza.dce9029d.png";